import { collection } from 'infra/collection'
import { TaxRefundMethodVersion } from './TaxRefundMethodVersion'
import { TaxRefundMethodVersionDto } from './dtos'
import { TaxRefundMethodsAPI } from './API'
import { Id } from 'types/definitions'
import {
  CreateTaxRefundMethodInput,
  UpdateTaxRefundMethodInput,
  mapCreateTaxRefundMethodRequestToProto,
  mapUpdateTaxRefundMethodRequestToProto,
} from './taxRefundMethodGrpcDtoMapper'

export default class TaxRefundMethodStore {
  taxRefundMethods = collection<
    TaxRefundMethodVersionDto,
    TaxRefundMethodVersion
  >({
    create: () => new TaxRefundMethodVersion(),
    getDataId: (data) => `${data.id}:${data.version}`,
    getModelId: (model) => `${model.id}:${model.version}`,
  })

  constructor(private api: TaxRefundMethodsAPI) {}

  /**
   * Gets tax refund method.
   */
  getTaxRefundMethod(id: Id, version: number) {
    return this.taxRefundMethods.get(`${id}:${version}`)
  }

  /**
   * Fetches business tax refund method for a given job ID.
   */
  async fetchBusinessTaxRefundMethodForJob(jobId: Id) {
    return this.api.getBusinessTaxRefundMethodForJob(jobId).then((method) => {
      return this.taxRefundMethods.set(method)
    })
  }

  /**
   * Fetches personal tax refund method for a given job ID.
   */
  async fetchPersonalTaxRefundMethodForJob(jobId: Id) {
    return this.api.getPersonalTaxRefundMethodForJob(jobId).then((method) => {
      return this.taxRefundMethods.set(method)
    })
  }

  /**
   * Creates a new tax refund method.
   */
  async createTaxRefundMethod(input: CreateTaxRefundMethodInput) {
    return this.api.createTaxRefundMethod(
      mapCreateTaxRefundMethodRequestToProto(input),
    )
  }

  /**
   * Updates an existing tax refund method.
   */
  async updateTaxRefundMethod(input: UpdateTaxRefundMethodInput) {
    return this.api.updateTaxRefundMethod(
      mapUpdateTaxRefundMethodRequestToProto(input),
    )
  }
}
